import axios from 'axios'
import {
  get,
  post,
  del
} from '@/http/request'
import {
  HOST
} from '@/http/config'

//修改密码
export function updatePassword(params) {
  return post(`${HOST}login/updatePassword`, params)
}
//工作台我的公文
export function officialDocumentMyOfficialDocument(params) {
  return get(`${HOST}official-document/MyOfficialDocument`, params)
}
//工作台我的新闻
export function getTheInformationRelease(params) {
  return get(`${HOST}the-information-release/Informationlist/`, params)
}
//工作台我的简报
export function briefingGetBreiefing(params) {
  return get(`${HOST}briefing/getBreiefing`, params)
}
//工作台我的申请
export function activityProcess(params) {
  return get(`${HOST}activity/process_handler/getMyStartTasks`, params)
}
//工作台我的app业务
export function appInfo() {
  return get(`${HOST}app-info/useList`)
}

// 简报预览
export function briefingCreateWord(params) {
  return get(`${HOST}briefing/createWord`, params)
}
// 公文预览
export function officialDocumentCreateWord(params) {
  return get(`${HOST}official-document/createWord`, params)
}
// 项目申请公文预览
export function projectApplyCreateWord(params) {
  return get(`${HOST}project-apply/createWord`, params)
}
// 消息中心
export function msgInfoList(params) {
  return get(`${HOST}msgInfo/list`, params)
}
// 业务申请
export function getAllProcess(params) {
  return get(`${HOST}activity/process_handler/getAllProcess`, params)
}



// WEBPACK FOOTER //
// ./src/views/workbench/api/api.js